import { render, staticRenderFns } from "./ShortDate.vue?vue&type=template&id=30bc931d"
import script from "./ShortDate.vue?vue&type=script&lang=js"
export * from "./ShortDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports